module.exports = __webpack_public_path__ + "static/la-vanguardia-c4e1b6e689ec871a9f1482f61283552f.png";